module.exports = __webpack_public_path__ + "img/icon16-call-in-success.4bef25ae.svg";